import React, { useState, useRef } from "react";

const EditTagsModal = ({ isOpen, onClose, tags: initialTags, onSave }) => {
  const [tags, setTags] = useState(initialTags || []);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  if (!isOpen) return null;

  const addTag = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !tags.includes(trimmed)) {
      setTags([...tags, trimmed]);
      setInputValue("");
    }
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  const handleSave = () => {
    onSave?.(tags);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-md"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="relative bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden"
        style={{ width: "644px" }}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-5 pb-3 flex-shrink-0">
          <h2 className="text-[22px] font-medium text-gray-900" style={{ fontFamily: "Inter" }}>
            Edit Interest Tags
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center rounded-full transition-colors"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6B7280"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6">
          {/* Description */}
          <p className="text-[14px] text-gray-500 mb-5" style={{ fontFamily: "Inter" }}>
            Add tags that represent your interests. Type a tag and press Enter to add.
          </p>

          {/* Tags Input Area - Similar to members input */}
          <div className="mb-6">
            <label className="block text-[17px] font-medium text-gray-700 mb-3" style={{ fontFamily: "Inter" }}>
              Interest Tags
            </label>
            
            <div className="border border-gray-200 rounded-xl p-3 bg-[#F9FAFB] min-h-[120px]">
              <div className="flex flex-wrap gap-2">
                {tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-full text-[13px] text-gray-700"
                    style={{ fontFamily: "Inter" }}
                  >
                    {tag}
                    <button
                      type="button"
                      onClick={() => removeTag(tag)}
                      className="text-gray-400 hover:text-gray-600"
                    >
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                      >
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </button>
                  </span>
                ))}
                
                {/* Text input for adding new tags */}
                <input
                  ref={inputRef}
                  type="text"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder={tags.length === 0 ? "Type a tag and press Enter..." : "Add more tags..."}
                  className="flex-1 min-w-[180px] px-3 py-1.5 bg-transparent text-[13px] text-gray-700 outline-none placeholder:text-gray-400"
                  style={{ fontFamily: "Inter" }}
                />
              </div>
            </div>
            <p className="text-[12px] text-gray-400 mt-2">Type a tag and press Enter to add</p>
          </div>
        </div>

        {/* Footer - Buttons */}
        <div className="flex justify-end gap-3 px-6 py-4 flex-shrink-0 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg text-[16px] font-normal hover:bg-gray-50 transition-all"
            style={{ fontFamily: "Inter" }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="px-6 py-2.5 bg-[#1F3A60] text-white rounded-lg text-[16px] font-normal hover:bg-[#2a4a7a] transition-all"
            style={{ fontFamily: "Inter" }}
          >
            Save Tags
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTagsModal;